import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http'
import { Animation } from '@ionic/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';

import { SharedModule } from './components/shared/shared.module';
import { TableModule } from 'primeng/table';


import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DocumentEditorModule } from '@txtextcontrol/tx-ng-document-editor';
import { AuthInterceptorService } from './auth-interceptor.service';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot({
    animated: false

  }), AppRoutingModule, HttpClientModule, BrowserAnimationsModule, SharedModule, TableModule, GooglePlaceModule],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, CookieService,{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule {

}
